/**
 * Using MutationObserver to check changes in children of Modal.
 * -> https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 *
 * - scrolls to modal bottom if necessary
 *
 * focusTrap library can do everything we need here,
 * maybe in future this can be coupled with the focusTrap library for better handling.
 */
export class ModalMutationObserver {
  constructor(reference) {
    this.reference = reference;

    this.mutationObserver = new MutationObserver(this.observerCallback.bind(this));
    // which mutations to observe
    this.mutationObserver.observe(reference, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * make sure to call this on componenWillUnmount
   */
  disconnect() {
    this.mutationObserver.disconnect();
  }

  observerCallback(mutationList) {
    mutationList.forEach((mutation) => {
      if (
        this.nodeWasAdded(mutation) &&
        this.addedNodeIsLiveRegion(mutation) &&
        this.addedNodeIsNotText(mutation.addedNodes)
      ) {
        this.scrollToBottom();
      }
    });
  }

  observerChildMutation(type, list) {
    return type === 'childList' && list && list.length > 0;
  }

  nodeWasAdded(mutation) {
    return this.observerChildMutation(mutation.type, mutation.addedNodes);
  }

  addedNodeIsLiveRegion(mutation) {
    // @ts-ignore classname is available on target
    return mutation.target && mutation.target.className === 'live-region';
  }

  addedNodeIsNotText(addedNodes) {
    for (let i = 0; i < addedNodes.length; i += 1) {
      if (addedNodes[i].nodeName !== '#text') {
        return true;
      }
    }

    return false;
  }

  /**
   * scrolling to the bottom of a modal.
   * currently only when live-region is added -> the "save" button is pressed.
   */
  scrollToBottom() {
    this.reference.scrollTop = this.reference.scrollHeight;
  }
}
